/**
 * Sugere quantas páginas/meses imprimir na mesma receita, conforme retorno e tamanho da embalagem.
 * Base: ~30 comprimidos = 1 mês de uso (ajustável).
 */

export function parsePackQuantity(quantity: unknown): number | null {
  if (quantity == null || quantity === '') return null;
  const s = String(quantity).replace(/\s/g, '');
  const m = s.match(/(\d+)/);
  if (!m) return null;
  const n = Number(m[1]);
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : null;
}

export type RenewalCoveragePlan = {
  /** Folhas a imprimir até o retorno. */
  sheets: number;
  /** Meses entre uma folha e a próxima (meses inteiros que cada folha cobre). */
  monthStep: number;
  /** Unidades dispensadas por folha (embalagem × 2 quando "2 embalagens"). */
  unitsPerSheet: number;
  /** Dias que uma folha cobre no consumo informado. */
  daysPerSheet: number;
  /** Embalagem não chega a cobrir um mês: cada folha deixa o paciente sem remédio antes da próxima. */
  insufficient: boolean;
};

export function planRenewalCoverage(params: {
  returnMonths: number;
  packQuantity: number;
  tabletsPerMonth?: number;
  /** @deprecated use packageCount */
  twoPackages?: boolean;
  packageCount?: number;
}): RenewalCoveragePlan {
  const returnMonths = Math.max(1, Math.min(24, Math.floor(Number(params.returnMonths) || 1)));
  const pack = Math.max(1, Math.floor(Number(params.packQuantity) || 1));
  const perMonth = Math.max(1, Math.floor(Number(params.tabletsPerMonth) || 30));
  const multiplier = Math.max(
    1,
    Math.floor(
      Number(params.packageCount)
        || (params.twoPackages ? 2 : 1),
    ),
  );
  const unitsPerSheet = pack * multiplier;
  // Só meses inteiros: 28 cp a 30/mês não cobrem um mês, e 90 cp cobrem 3.
  const wholeMonths = Math.floor(unitsPerSheet / perMonth);
  const monthStep = Math.max(1, wholeMonths);
  const sheets = Math.min(12, Math.max(1, Math.ceil(returnMonths / monthStep)));
  return {
    sheets,
    monthStep,
    unitsPerSheet,
    daysPerSheet: Math.floor((unitsPerSheet / perMonth) * 30),
    insufficient: wholeMonths < 1,
  };
}

export function suggestPrintMonthCount(params: {
  returnMonths: number;
  packQuantity: number;
  tabletsPerMonth?: number;
  twoPackages?: boolean;
  packageCount?: number;
}): number {
  return planRenewalCoverage(params).sheets;
}
